import * as React from 'react'
import * as UI from '@brewlogix/blx-ui'
import AlsoLikeCard from './AlsoLikeCard'
import { Location } from 'src/types/schema/graphql'
import classNames from 'classnames'
import { useLocationSlugStore } from 'src/features/locations/state/useLocationSlugStore'

interface PeopleAlsoLikeProps {
    location: Location
}

const PeopleAlsoLike: React.FC<PeopleAlsoLikeProps> = ({ location }) => {
    const { resetState, getLocations, suggestedLocations } = useLocationSlugStore()

    React.useEffect(() => {
        resetState()
        getLocations(location)
    }, [])

    const filteredLocations = [...suggestedLocations]
        .filter((locObj) => locObj.location?.traits?.isOpenToPublic)
        .slice(0, 3)

    return (
        <>
            {filteredLocations.length > 0 && (
                <div className={classNames('mt-20 w-full space-y-6')} id='amenities'>
                    <UI.Heading
                        text='You May Also Like'
                        size='h4'
                        type='h2'
                        customClasses='text-xl lg:text-2xl text-gray-500 font-extrabold'
                    />
                    <div className='flex w-full flex-col gap-4 md:flex-row'>
                        {filteredLocations.map((locObj) => (
                            <AlsoLikeCard
                                key={locObj.location?.id}
                                location={locObj.location}
                                distance={locObj.distance}
                            />
                        ))}
                    </div>
                </div>
            )}
        </>
    )
}

export default PeopleAlsoLike
